import { ComponentProps, ReactNode, createContext, useState } from "react";

const defaultValue = {
  pageData: {},
};

export const AppContext = createContext<any>({
  tagQuery: null,
  setTagQuery: () => {},
});

export const PageContext = createContext(defaultValue);

interface PageProviderProps
  extends ComponentProps<typeof PageContext.Provider> {
  children: ReactNode;
  value: any;
}

export const PageProvider = ({ children, ...props }: PageProviderProps) => {
  return <PageContext.Provider {...props}>{children}</PageContext.Provider>;
};

export const BlogProvider = ({ children }: any) => {
  const [tagQuery, setTagQuery] = useState<any>({ tag: "all", page: 1 });

  return (
    <AppContext.Provider value={{ tagQuery, setTagQuery }}>
      {children}
    </AppContext.Provider>
  );
};
